import { render } from "./Branding.vue?vue&type=template&id=742a409f&scoped=true&ts=true"
import script from "./Branding.vue?vue&type=script&lang=ts"
export * from "./Branding.vue?vue&type=script&lang=ts"

import "./branding.scss?vue&type=style&index=0&id=742a409f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742a409f"]])

export default __exports__